class Drawer {
  constructor() {
    this.drawers = document.querySelectorAll('.drawer');
    this.activeDrawer = null;
    this.previousActiveElement = null;
    this.header = document.querySelector('.site-header');
    this.announcementBar = document.querySelector('.announcement-bar');
    this.headerGroup = document.querySelector('.header-group');
    this.headerHeight = this.header ? this.header.offsetHeight : 76;
    this.setDrawerTopPosition();
    this.init();
  }

  // Establecer la posición superior de los drawers para que coincida con el header
  setDrawerTopPosition() {
    const announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
    const totalTopOffset = this.headerHeight + announcementBarHeight;
    
    document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
    document.documentElement.style.setProperty('--drawer-top-offset', `${totalTopOffset}px`);
    
    // Aplicar la altura total como posición superior para los drawers y overlays
    document.querySelectorAll('.drawer, .drawer-overlay').forEach(el => {
      el.style.top = totalTopOffset + 'px';
    });

    // Actualizar la posición cuando cambie el tamaño de la ventana
    window.addEventListener('resize', () => {
      // Recalcular la altura del header en caso de que haya cambiado
      this.headerHeight = this.header ? this.header.offsetHeight : 76;
      const updatedAnnouncementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      const updatedTotalTopOffset = this.headerHeight + updatedAnnouncementBarHeight;
      
      document.documentElement.style.setProperty('--drawer-top-offset', `${updatedTotalTopOffset}px`);
      document.querySelectorAll('.drawer, .drawer-overlay').forEach(el => {
        el.style.top = updatedTotalTopOffset + 'px';
      });
    });
  }

  init() {
    // Manejador para abrir drawers
    document.addEventListener('click', (event) => {
      const toggleButton = event.target.closest('[data-drawer-toggle]');
      if (toggleButton) {
        event.preventDefault();
        const drawerId = toggleButton.getAttribute('data-drawer-toggle');
        const position = toggleButton.getAttribute('data-drawer-position') || 'right';
        this.openDrawer(drawerId, position);
      }
    });

    // Manejador para cerrar drawers
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('drawer-overlay') || 
          event.target.closest('.js-drawer-close')) {
        event.preventDefault();
        this.closeAllDrawers();
      }
    });

    // Cerrar con la tecla ESC
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeAllDrawers();
      }
    });

    // Prevenir scroll en el body cuando el drawer está abierto
    this.drawers.forEach(drawer => {
      drawer.addEventListener('transitionend', () => {
        if (drawer.getAttribute('aria-hidden') === 'true') {
          document.body.style.overflow = '';
        }
      });
    });

    // Manejador para cerrar al hacer clic en el overlay
    document.addEventListener('click', (event) => {
      if (event.target.matches('.drawer-overlay')) {
        const drawerId = event.target.getAttribute('data-drawer-overlay');
        this.closeDrawer(drawerId);
      }
    });
  }

  openDrawer(drawerId, position) {
    const drawer = document.querySelector(`[data-drawer-id="${drawerId}"]`);
    const overlay = document.querySelector(`[data-drawer-overlay="${drawerId}"]`);
    
    if (drawer) {
      this.closeAllDrawers();
      
      this.previousActiveElement = document.activeElement;
      
      drawer.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('data-position', position);
      drawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('drawer-open');
      this.activeDrawer = drawer;

      overlay.classList.add('active');
      
      // Hacer visible el header forzosamente antes de abrir el drawer
      if (this.headerGroup) {
        // Asegurarnos de que el header-group sea visible antes de abrir el drawer
        this.headerGroup.classList.remove('header-group--hidden');
        this.headerGroup.classList.add('drawer-is-open');
        
        // Forzar un repaint para que el header sea visible inmediatamente
        void this.headerGroup.offsetWidth;
      }
      
      // Añadir clase al header para indicar que hay un drawer abierto
      if (this.header) {
        this.header.classList.add('drawer-is-open');
        // Añadir clase específica para el drawer de búsqueda
        if (drawerId === 'search') {
          this.header.classList.add('search-drawer-is-open');
        }
        // Asegurar que el header sea visible cuando un drawer está abierto
        this.header.classList.remove('header--hidden');
        
        // Forzar un repaint para que el header sea visible inmediatamente
        void this.header.offsetWidth;
      }
      
      // Asegurar que el announcement bar sea visible
      if (this.announcementBar) {
        this.announcementBar.classList.remove('announcement--hidden');
      }

      drawer.classList.remove('drawer--left', 'drawer--right');
      drawer.classList.add(`drawer--${position}`);
      
      // Recalcular la posición del drawer en caso de que el header acaba de hacerse visible
      if (this.headerGroup || this.header) {
        setTimeout(() => this.setDrawerTopPosition(), 0);
      }
    }
  }

  closeDrawer(drawerId) {
    const drawer = document.querySelector(`[data-drawer-id="${drawerId}"]`);
    const overlay = document.querySelector(`[data-drawer-overlay="${drawerId}"]`);
    
    if (drawer) {
      const focusedElement = document.activeElement;
      if (drawer.contains(focusedElement)) {
        const toggleButton = document.querySelector(`[data-drawer-toggle="${drawerId}"]`);
        if (toggleButton) {
          toggleButton.focus();
        } else if (this.previousActiveElement) {
          this.previousActiveElement.focus();
        }
      }
      
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      document.body.classList.remove('drawer-open');
      this.activeDrawer = null;

      // Remover clases del header cuando se cierra el drawer
      if (this.header) {
        this.header.classList.remove('drawer-is-open');
        // Remover clase específica para el drawer de búsqueda
        if (drawerId === 'search') {
          this.header.classList.remove('search-drawer-is-open');
        }
      }
      
      // Eliminar la clase drawer-is-open del header-group
      if (this.headerGroup) {
        this.headerGroup.classList.remove('drawer-is-open');
      }
    }
  }

  closeAllDrawers() {
    this.drawers.forEach(drawer => {
      const drawerId = drawer.getAttribute('data-drawer-id');
      this.closeDrawer(drawerId);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Drawer();
});